import { Grid } from '@mui/material';
import Box from '@mui/material/Box';

export default function FormInputLabel({ 
    label, 
    subText = '', 
    labelSize = 6, 
    labelBottomMargin = '-mb-3', 
    required = false,
    actionLink = null,
    style = {}
}) {
    return (
        <Grid
            item
            xs={labelSize}
            className={'flex flex-row items-center justify-between'}
            sx={{
                marginBottom: '0px',
                display: 'flex',
                alignItems: 'center',
                alignSelf: 'flex-start',
                ...style,
            }}
        >
            <label className={'poppins-bold ' + labelBottomMargin} style={{ marginBottom: '0px' }}>
                {label}
                {required && <span style={{ color: '#ff5f39', marginLeft: '4px' }}>*</span>}
            </label>
            {actionLink && <div>{actionLink}</div>}
            {subText && <Box className={'ml-1 mt-3'}>{subText}</Box>}
        </Grid>
    );
}
